module.exports = __webpack_public_path__ + "static/media/receba_ja.ce874895.svg";